import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-user-creation',
    templateUrl: './user-creation.component.html',
    styleUrls: ['./user-creation.component.scss'],
    standalone: false
})
export class UserCreationComponent {
    constructor(public dialogRef: MatDialogRef<UserCreationComponent>) {}
}
